import React from 'react';
import { GridApi } from '@ag-grid-community/core';
import { ActionDropdown } from '@urc-ui/components/action-dropdown';
import { useActions } from '@urc-ui/hooks/actions';
import styled from 'styled-components';
import { ActionSource } from '@urc-ui/hooks/actions/types';
import { Subscription } from '@urc-ui/store/api/subscriptions/types';
import { TAKT_EVENT_SOURCE } from '@urc-ui/hooks/takt-logger';

const StyledContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.mini};
`;

interface ActionDropdownRendererProps {
  value: {
    // Subscriptions details for the selected subscription
    subscription: Subscription;
    api: GridApi;
  };
}

const ActionDropdownRenderer = ({ value }: ActionDropdownRendererProps) => {
  const { onRunReportAction, onDeleteReportAction, onCopyReportAction } = useActions({
    gridApi: value.api,
    subscription: value.subscription,
    taktEventSource: TAKT_EVENT_SOURCE.SUBSCRIPTION_TABLE,
    source: ActionSource.SUBSCRIPTION_TABLE
  });

  return (
    <StyledContainer>
      <ActionDropdown onRunReport={onRunReportAction} onCopyReport={onCopyReportAction} onDeleteReport={onDeleteReportAction} />
    </StyledContainer>
  );
};

export { ActionDropdownRenderer };
